// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__tDhtC","infoWrapper":"styles_infoWrapper__3vMTe","info":"styles_info__1dfMQ","buttonWrapper":"styles_buttonWrapper__8vzbW","buttonClass":"styles_buttonClass__T3SNM"};
module.exports.__checksum = "e5035ccd2000"
